export const ops = ['>', '>=', '<', '<=', '=', '!='];
export const functions = ['cur', 'diff', 'diff_abs', 'diff_percent', 'diff_percent_abs', 'query_percent', 'nodata'];
export const functionsNameMap = {
  cur: '当前值',
  diff: '变化值',
  diff_abs: '变化值绝对值',
  diff_percent: '变化百分比',
  diff_percent_abs: '变化百分比绝对值',
  query_percent: '查询占比',
  nodata: '无数据',
};
